// Port of src/app/components/nav-bar/playlist-icon/playlist-icon.component.{ts,html}
// (mypart-playlist-icon). The Angular .scss file was empty — no stylesheet.
// [imageLoader] + ngSrc/fill → AppImage with NgOptimizedImage's fill styles.

import type { CSSProperties } from 'react';
import AppImage from '../../shared/components/AppImage';

export interface PlaylistIconProps {
  totalPlaylistSongs: number;
  onShowPlaylist: () => void;
}

const fillStyle: CSSProperties = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%'
};

export default function PlaylistIcon({ totalPlaylistSongs, onShowPlaylist }: PlaylistIconProps) {
  if (totalPlaylistSongs <= 0) {
    return null;
  }

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        onShowPlaylist();
      }}
      className="w-full flex items-center cursor-pointer text-gray-700 dark:text-gray-400
            hover:text-gray-900 hover:underline dark:hover:text-white relative mr-2">
      <figure className="w-6 h-5 relative">
        <AppImage
          alt={'The image shows a red icon with three horizontal bars stacked vertically on the left ' +
            'side and a downward-pointing arrow on the right side. Each element is outlined in white, making ' +
            'them stand out against the black background. The three bars represent a list, and the downward ' +
            'arrow indicates an action related to viewing or expanding this list, such as opening or viewing ' +
            'a playlist. The design is clean and modern, clearly communicating its function.'}
          src="https://d382nvfdu38z2f.cloudfront.net/songhunt/mobile_playlist.png"
          style={fillStyle}
          fetchPriority="high"
        />
      </figure>
      <div className="absolute inline-flex items-center justify-center w-5 h-5 text-[0.625rem] font-bold text-white bg-red-500
                    border-2 border-white rounded-full -top-2 -right-2 dark:border-gray-900">
        {totalPlaylistSongs}
      </div>
    </div>
  );
}
